import { Model as ORMModel, attr, many, fk } from "redux-orm";
import { SegmentsMeta, defaultSegmentDuration } from "@fedsim/constants";
import { getId } from "@fedsim/helpers";
import { Types } from "@fedsim/actions";

export class Segment extends ORMModel {
  static get types() {
    return SegmentsMeta;
  }
  static get fields() {
    return {
      id: attr(),
      name: attr({ getDefault: () => "" }),
      desc: attr({ getDefault: () => "" }),
      date: attr({ getDefault: () => new Date() }),
      type: attr({ getDefault: () => SegmentsMeta.DEFAULT }),
      championshipIds: many({
        to: "Championship",
        as: "championships",
        relatedName: "segmentChampionships",
      }),
      feudId: fk({
        to: "Feud",
        as: "feud",
        relatedName: "SegmentFeud",
      }),
      duration: attr({ getDefault: () => defaultSegmentDuration }),
      complete: attr({ getDefault: () => false }),
      rating: attr({ getDefault: () => 0 }),
      // new vars
      withEntrances: attr({ getDefault: () => false }),
      withInterference: attr({ getDefault: () => false }),
      withCountout: attr({ getDefault: () => 0 }),
      wasThrownout: attr({ getDefault: () => false }),
    };
  }
  static reducer(action, Segment, session) {
    let item;
    switch (action.type) {
      case Types.GENERATE_SEGMENTS:
        action?.payload?.forEach(newItem => {
          session.Segment.upsert(newItem)
        })
        break
      case Types.RESET:
      case Types.RESET_SEGMENTS:
        session.Segment.all()
          .toModelArray()
          .forEach((item) => item.delete());
        break;
      case Types.SIMULATE_SEGMENT:
        item = Segment.withId(action.payload.id);

        item.update({ complete: true, ...action.payload });

        break;
      case Types.PRODUCTION_COMPLETE_SEGMENTS:
        {
          const production = session.Production.withId(action.payload.id);
          const segments = session.Segment.all()
            .filter((item) => production.segmentIds.includes(item.id))
            .toModelArray();

          segments.forEach((item) => {
            const foundItem = session.Segment.withId(item.id);
            if (foundItem) {
              foundItem.update({ complete: true });
            }
          });
        }
        break;
      case Types.RANDOMISE_SEGMENT:
        if (action?.payload?.segmentId) {
          item = Segment.withId(action?.payload?.segmentId);

          item.update({ complete: false, });
        }
        break;
      case Types.ADD_SEGMENT:
        {
          const cost = Segment.types[action.payload?.type || "DEFAULT"].cost;
          const id = action.payload?.id || getId();

          Segment.upsert({ id, cost, ...action.payload });
        }
        break;
      case Types.UPDATE_SEGMENT:
        {
          const cost = Segment.types[action.payload?.type || "DEFAULT"].cost;

          item = Segment.withId(action.payload.id);

          item.update({ cost, ...action.payload });
        }
        break;
      case Types.DELETE_SEGMENT: {
        Segment.withId(action.payload.id).delete();
        break;
      }
    }
  }
}

export default Segment;
